import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import ScrollToTop from "./layout/ScrollToTop";
import Loading from "../Component/Loader";
import Page from "../Pages";
import SignUpModalHost from "../revamp/components/signup-modal-host";
import { useJsonLd } from "../revamp/hooks/use-page-meta";
import { cleanSocialLink } from "../revamp/components/site-footer";
import { site } from "../revamp/lib/content";
import { isMarketingPath, useAppChromeCss } from "../revamp/hooks/use-app-chrome-css";
import "bootstrap/dist/css/bootstrap.min.css";
// import "./../assets/css/mentor.new.css";
import "./../assets/css/app.css";
import "./../assets/css/media.css";
// 5th Anniversary revamp stylesheet — scoped under .vl-revamp, generated by `npm run revamp:css`.
// Imported last on purpose: it must come after bootstrap/app.css in the bundle.
import "./../revamp/styles/revamp.css";
import "./../revamp/styles/auth-restyle.css"; // login/register/forgot/reset in the new look (task 21)

const App = (props) => {
  const { isFetching, isAuth } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  var redirectTo = useSelector((state) => state.redirectTo);
  const location = useLocation();
  useAppChromeCss(!isMarketingPath(location.pathname));
  const setting = useSelector((state) => state.setting) || {};
  const sameAs = [
    cleanSocialLink(setting.linkedin_link),
    cleanSocialLink(setting.twitter_link),
    cleanSocialLink(setting.facebook_link),
    cleanSocialLink(setting.instagram_link),
    cleanSocialLink(setting.youtube_link),
    cleanSocialLink(setting.spotify_link),
  ].filter(Boolean);
  useJsonLd("ld-organization", {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://www.vlookup.ai/#organization",
        name: site.name,
        url: "https://www.vlookup.ai/",
        logo: "https://www.vlookup.ai/assets/images/vlookup-og-image.png",
        email: setting.support_email || site.email,
        sameAs,
      },
      {
        "@type": "WebSite",
        "@id": "https://www.vlookup.ai/#website",
        url: "https://www.vlookup.ai/",
        name: site.name,
        description: site.description,
        publisher: { "@id": "https://www.vlookup.ai/#organization" },
      },
    ],
  });

  useEffect(() => {
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.href = window.location.origin + location.pathname;
    }
  }, [location]);

  useEffect(() => {
    if (redirectTo.redirectTo) {
      dispatch({
        type: "REDIRECT",
        payload: false,
      });
      history.push(redirectTo.redirectTo);
    }
  });

  useEffect(() => {
    if (location?.pathname !== '/register') {
      localStorage.removeItem('fromId')
    }

  }, [location])
  return (
    <>
      {isFetching && <Loading />}
      <ScrollToTop />
      <Page isAuth={isAuth} />
      <SignUpModalHost />
    </>
  );
};

function mapStateToProps(state) {
  return {
    isFetching: state.isFetching,
    isAuth: state.isAuth,
  };
}

export default connect(mapStateToProps)(App);
